<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from '@/plugins/i18n'
import { useSearchStore } from '@/components/Search/store/index'
import AllFiltersModal from '@/components/Search/SearchBar/AllFiltersModal/index.ce.vue';
import FilterDropdown from '@/components/Search/FilterDropdown.ce.vue';

import iconStatus from '@/assets/img/icon-search-filter-status.svg';
import iconOpenStatus from '@/assets/img/icon-search-filter-status-active.svg';
import iconPublisher from '@/assets/img/icon-search-filter-publisher.svg';
import iconOpenPublisher from '@/assets/img/icon-search-filter-publisher-active.svg';
import iconCountry from '@/assets/img/icon-search-filter-country.svg';
import iconOpenCountry from '@/assets/img/icon-search-filter-country-active.svg';
import iconCategories from '@/assets/img/icon-search-filter-categories.svg';
import iconOpenCategories from '@/assets/img/icon-search-filter-categories-active.svg';
import iconOpen from '@/assets/img/icon-search-filter-up-open.svg';
import iconClose from '@/assets/img/icon-search-filter-down.svg';
import { STANDARDS_SEARCH_TAB } from '@/components/Search/constants.ts';
import CategoriesFilter from '@/components/Search/SearchFilters/Common/CategoriesFilter/index.ce.vue';
import CrossReferenceSuggest from '@/components/Search/CrossReferenceSuggest.ce.vue';

//refs
const displayAllFiltersDisplay = ref(false);

//store
const searchStore = useSearchStore()

//translations
const i18nInstance: any = useI18n()
const { t } = i18nInstance

//event handlers
const handleStandardsAllFiltersDisplay = (display: boolean) => {
  displayAllFiltersDisplay.value = display
}

const handleSearch = () => {
  searchStore.searchStandards(false);
  handleStandardsAllFiltersDisplay(false);
}
</script>

<template>
  <div class="search-bar-filters">
    <div class="search-filter-item cross-reference">
      <CrossReferenceSuggest
        v-model="searchStore[`${STANDARDS_SEARCH_TAB}.crossReference`]"
        :placeholder="t('crossReferencePlaceHolder')"
        :matchInputWidth="true"
        :dropdownExtraWidth="25"
        inputClass="crossref-input searchbar-crossref-input"
        @select="searchStore.searchStandards(true)"
      />
    </div>
    <div class="search-filter-item multiselect publisher">
      <FilterDropdown
        className="dropdown"
        :placeholder="t('publisher')"
        :searchPlaceholder="t('searchPublisherPlaceholder')"
        name="publisher[]"
        :multiple="true"
        :field="`${STANDARDS_SEARCH_TAB}.publisher`"
        :lookupField="`lookUpOptions.${STANDARDS_SEARCH_TAB}.publisher`"
        :hasClear="true"
        :iconMain="iconPublisher"
        :iconOpenMain="iconOpenPublisher"
        :iconOpen="iconOpen"
        :iconClose="iconClose"
        :searchable="true"
        :showMoreLink="false"
        :closeOnClickOutside="true"
        :loadOptionsOnClick="true" />
    </div>
    <div class="search-filter-item multiselect status">
      <FilterDropdown
        className="dropdown"
        :placeholder="t('status')"
        name="status"
        :multiple="true"
        :field="`${STANDARDS_SEARCH_TAB}.status`"
        :lookupField="`lookUpOptions.${STANDARDS_SEARCH_TAB}.status`"
        :hasClear="true"
        :iconMain="iconStatus"
        :iconOpenMain="iconOpenStatus"
        :iconOpen="iconOpen"
        :iconClose="iconClose"
        :showMoreLink="false"
        :closeOnClickOutside="true"
        :loadOptionsOnClick="false"
      />
    </div>
    <div class="search-filter-item multiselect country">
      <FilterDropdown
        className="dropdown"
        :placeholder="t('country')"
        name="country"
        :field="`${STANDARDS_SEARCH_TAB}.country`"
        :lookupField="`lookUpOptions.${STANDARDS_SEARCH_TAB}.country`"
        :hasClear="true"
        :iconMain="iconCountry"
        :iconOpenMain="iconOpenCountry"
        :iconOpen="iconOpen"
        :iconClose="iconClose"
        :showMoreLink="false"
        :closeOnClickOutside="true"
        :loadOptionsOnClick="true"
      />
    </div>
    <div class="search-filter-item multiselect categories">
      <CategoriesFilter :searchType="STANDARDS_SEARCH_TAB"
                        className="dropdown"
                        :useTeleport="false"
                        :closeOnClickOutside="true"
                        :iconMain="iconCategories"
                        :iconOpenMain="iconOpenCategories"
                        :iconOpen="iconOpen"
                        :iconClose="iconClose">
      </CategoriesFilter>
    </div>
    <div class="search-filter-item cta">
        <div class="all-filters">
            <AllFiltersModal :display="displayAllFiltersDisplay" @closeModal="handleStandardsAllFiltersDisplay(false)"  @handleSearch="handleSearch"></AllFiltersModal>
            <div class="search-bar-all-filter" @click="handleStandardsAllFiltersDisplay(true)">{{t('allFIlters')}}</div>
        </div>
        <div class="clear-all">
            <div class="search-bar-clear-filter" @click="searchStore.clearSearchBarFilters(STANDARDS_SEARCH_TAB, [])">{{t('clearAll')}}</div>
        </div>
        <div class="spacer">&nbsp;</div>
        <div class="search">
            <div class="search-bar-btn-search" @click="searchStore.searchStandards(false)">&nbsp;</div>
        </div>
    </div>
  </div>
</template>
